import * as Constants from '../constants/action-constants';
import { SettingGroup } from 'vrlcm-gui-types';

export interface RequestSettings {
  type: Constants.REQUEST_SETTINGS;
}

export interface RequestSettingsSuccess {
  type: Constants.REQUEST_SETTINGS_SUCCESS;
  payload: {
    groups: SettingGroup[];
  };
}

export type SettingsAction = RequestSettings | RequestSettingsSuccess;

export const requestSettings = (): RequestSettings => ({
  type: Constants.REQUEST_SETTINGS
});

export const requestSettingsSuccess = (
  groups: SettingGroup[]
): RequestSettingsSuccess => ({
  payload: { groups },
  type: Constants.REQUEST_SETTINGS_SUCCESS
});
